import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { NotificationSettingsModel } from '../models/notification_settings_model';

angular
  .module('capability-ng-notification-settings')
  .factory(
    'updateNotificationSettingsCommand',
    function updateNotificationSettingsCommandDefinition(
      defineCommand: IDefineCommand,
      notificationSettingsModel: NotificationSettingsModel,
      $http: ng.IHttpService
    ) {
      return defineCommand(
        'updateNotificationSettingsCommand',
        function updateNotificationSettingsCommand(
          deferred: any,
          nk: string,
          isActive: boolean,
          currentChannel: string
        ) {
          $http
            .post('notification/student/preferences/', {
              category: nk,
              is_active: isActive,
              channel: currentChannel
            })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              const updatedPreference = notificationSettingsModel.updatePreferenceFromServer(data);
              deferred.resolve({
                updatedCategory: _4.get(updatedPreference, 'title', ''),
                channel: currentChannel
              });
            })
            .catch(() => {
              deferred.reject(`Failed to save your preference for ${currentChannel}`);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/commands/update_notification_settings_command.ts